
































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import moment from "moment";
import MyForm from "@/mixins/form";

import SelectUsers from "@/components/selectusers.vue";

@Component({
  components: {
    SelectUsers
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;
  @Prop() dmarketingType!: number;

  handleSubmit() {
    this.form.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldsValue) {
              if (_.get(fieldsValue, [key])) {
                const fieldValue = _.get(fieldsValue, [key]);

                if (fieldValue) {
                  if (moment.isMoment(fieldValue)) {
                    _.set(
                      values,
                      [key],
                      moment(fieldValue).format("YYYY-MM-DD HH:00:00")
                    );
                  } else if (_.isArray(fieldValue)) {
                    _.set(values, [key], JSON.stringify(fieldValue));
                  } else {
                    _.set(values, [key], fieldValue);
                  }
                }
              }
            }
            const res = await this.$store.dispatch("dmarketing/add", {
              stadium_id: this.stadiumId,
              dmarketing_type: this.dmarketingType,
              ...values
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }
}
